import React from 'react'
import {Translate} from 'react-localize-redux';
import { PERSONAL_DATA_FIELDS, encryptData, decryptData, generateKey, postErrorSlack } from '../../../../utils/index.jsx';
import { getPersonalDataKek, encryptPersonalFieldV2 } from '../../../../utils/personalDataV2';
import { toStoredPlaintext } from '../../../../utils/personalDataEdit';
import Form from '../../../general/form';
import { Grid, Typography } from '@mui/material';

export default function PersonalDataForm(props) {
    const orderedFields = React.useMemo(() => {
        return props.fields.sort((a,b) => a.order - b.order);
    }, [props.fields]);
    const form = React.useMemo(() => {
        let formObj = {};
        for (let i = 0; i < orderedFields.length; i++) {
            const value = orderedFields[i];
            formObj[value.name] = orderedFields[i];
        }
        return formObj;
    }, [orderedFields]);

    // Encrypts the patient's personal data before it is sent to the API.
    // v2 (props.useV2): AES-256-GCM with the investigation's personal_data KEK — each field gets a nonce.
    // v1: legacy CryptoJS with the investigation key derived from the researcher key.
    async function encryptPersonalData(data){
        if(!localStorage.getItem("password")){
            console.error("No password stored!");
            return "error";
        }

        const useV2 = props.useV2;
        let rawKeyInvestigation = null;
        let personalDataKek = null;
        if(useV2){
            try{
                personalDataKek = await getPersonalDataKek(props.investigationUuid);
            }
            catch(e){
                console.error("No personal_data KEK available for v2 encryption:", e);
                return "error";
            }
        }
        else{
            const rawKeyResearcher = localStorage.getItem("rawKeyResearcher");
            rawKeyInvestigation = decryptData(props.keyResearcherInvestigation, rawKeyResearcher);
        }

        let encryptedData = [];

        for (const key of Object.keys(data)) {
            let value = data[key];
            const fieldForm = props.fields.find(field => field.name === key);
            if(fieldForm){
                const field = form[key];
                let nonce = null;
                if(fieldForm.encrypted !== false){
                    // The same normalisation decides what counts as a change (SKIN-374)
                    value = toStoredPlaintext(fieldForm, value);
                    if(useV2){
                        const encrypted = await encryptPersonalFieldV2(value.toString(), personalDataKek);
                        value = encrypted.value;
                        nonce = encrypted.nonce;
                    }
                    else{
                        value = encryptData(value.toString(), rawKeyInvestigation);
                    }
                }
                field.value = value;
                field.nonce = nonce;
                encryptedData.push(field)
            }
            else{
                postErrorSlack("", "fieldForm no found:"+key , "");
            }
        }

        if(useV2){
            // v2 KEKs live in the researcher account; no patient-password-wrapped key.
            props.callBackForm({
                "personalData" : encryptedData
            }, data);
        }
        else{
            //Generación de claves de paciente de Sherwood
            const rawKeyPatient = import.meta.env.VITE_APP_DEFAULT_PATIENT_PASSWORD;// o la clave que se imprime
            const patientKeyEncrInvestigation = encryptData(rawKeyInvestigation, rawKeyPatient);

            props.callBackForm({
                "keyPatInv" : patientKeyEncrInvestigation,
                "personalData" : encryptedData
            }, data);
        }
    }
    function renderHeader(){
        if(props.hospital){
            return(
                <Typography variant="body2" color="textPrimary">
                    <Translate id="hospital.patient.fill-in" />
                </Typography>
            )
        }
        else{
            return(
                <React.Fragment>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" color="textPrimary">
                            <Translate id="investigation.fill.personal_data.title" />
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" color="textPrimary">
                            <Translate id="investigation.fill.personal_data.description" />
                        </Typography>
                    </Grid>
                </React.Fragment>
            )
        }
    }
    const personalFields = {};
    
    if(JSON.stringify(form) === '{}'){
        return "LOading"
    }
    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                {renderHeader()}
            </Grid>
            <Grid item xs={12}>
                <Form fields={form} initialData={props.initialData} submitText={props.submitText}
                    callBackForm={(data) => encryptPersonalData(data)}/>
            </Grid>
        </Grid>
    )    
}
